import styled from "styled-components";

export const AddManagerStyles = styled.div`
  .modalHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
